module.exports = __webpack_public_path__ + "img/logo-clover.73b4f565.svg";